<template>
<div>
    <div class="img-area" @click="onClickImage">
        <b-icon-plus-circle v-show="selected!==null" scale="2" class="marker" :style="markerStyle" variant="success" :shift-v="marker.y" :shift-h="marker.x">
        </b-icon-plus-circle>
        <b-img 
            ref="image"
            :src="decodedImage" 
            fluid
            class="hotspot-img"
        ></b-img>
    </div>
    <!-- <h2>{{selected}}</h2>
    <h2>{{displayRatio}}</h2> -->
</div>
</template>

<script>
export default {
  data () {
    return {
        markerStyle: null,
        marker: {
          x: null,
          y: null
        },
        selected: null,
        displayRatio: null,
    }
  },
  computed: {
    decodedImage () {
        return `data:image/jpeg;base64, ${this.encodedFile}`
    }
  },
  props: {
    question: Object,
    encodedFile: String,
  },
  methods: {
    onClickImage(event= MouseEvent) {
        if (this.displayRatio==null || this.displayRatio==0){
          this.displayRatio = this.getDisplayRatio()
        }
        this.marker.x= parseInt(event.offsetX)-8,
        this.marker.y= parseInt("-"+event.offsetY)+8,
        this.markerStyle = "display:block"
        if(this.displayRatio>0) {
        this.selected = `${parseInt(event.offsetX * this.displayRatio)} ${parseInt(event.offsetY * this.displayRatio)}`
        } else {
          this.selected = null
        }
        
        this.$emit('update-selected', this.selected)
    },
    getDisplayRatio() {
        let img = new Image();
        img.src = this.decodedImage;
        return img.width / this.$refs.image.width
    },
    resizeHandler() {
        this.displayRatio = this.getDisplayRatio()
        if (this.selected != null) {
          this.marker.x= (this.selected.split(' ')[0] / this.displayRatio)-8
          this.marker.y= -(this.selected.split(' ')[1] / this.displayRatio)+8
        }
    }
  },
  created() {
    window.addEventListener("resize", this.resizeHandler);
  },
  destroyed() {
    window.removeEventListener("resize", this.resizeHandler);
  },
  watch: {
    question: function() {
        this.selected = null
        this.displayRatio = null
    }
  }
}
</script>

<style scoped>
.img-area:hover {
    cursor: crosshair
}
.marker {
    position: absolute;
}
.img-area {
    width: fit-content;
    margin: auto
}
hotspot-img {
    min-width: 100%;
}
</style>